// extracted by mini-css-extract-plugin
export default {"container":"MarkerPopup_container__14X1G","practitioner-list":"MarkerPopup_practitioner-list__vdjGl"};